import React, { Fragment, useCallback, useEffect, useState } from "react"
import { PlusCircleIcon } from "@heroicons/react/outline"
import { useHistory } from "react-router-dom"
import { GO_DE_GQL_BACKEND_URL, Routes } from "../../../constants"
import { useApi } from "../../../contexts/ApiContext"
import NotificationList from "../../../components/NotificationList"
import Button from "../../../components/Button"
import { CollectionStage, CollectionState, UserMetadata } from "../../../types"
import { useAuth } from "../../../contexts/AuthContext"
import { InputField } from "../../../components/InputField"
import SearchList from "../../../components/SearchList"
import DraftList from "../../../components/DraftList"
import { useBlockchain } from "../../../contexts/blockchain"
import { Blockchain } from "../ManageDraft/types"
import { FetchApi } from "../../../api/fetch"



const AdminNotifications = React.memo(() => {
  const [tab, setTab] = useState(0)
  const [searchText, setSearchText] = useState("")
  const [searchItems, setSearchItems] = useState<any[]>([])
  const history = useHistory()

  const { currentBlockchain, setCurrentBlockchain }: any = useBlockchain()

  const onAddNewCollection = useCallback(() => {
    history.push(`${Routes.MANAGE_DRAFT}/`)
  }, [history])


  useEffect(() => {
    (async () => {
      const val = `${searchText}%`
      if (searchText.length >= 2) {
        if (currentBlockchain != Blockchain.Bitcoin) {
          const collections: any[] = await searchCollectionsSolana(val) || []
          setSearchItems(collections)
        } else {
          const collections: any[] = await searchCollectionsBitcoin(val) || []
          setSearchItems(collections)
        }

      }
    })()
  }, [searchText])


  const searchCollectionsSolana = async (val: string) => {
    const collectionsPromise = await FetchApi({
      endpoint:`${GO_DE_GQL_BACKEND_URL}`, 
      method: "POST",
      body:  ({
        query: `
          query MyQuery($name: String) {
            collections(name: $name) {
              nodes {
                name
                id
              }
            }
            draftCollections(name: $name) {
              nodes {
                name
                id
                state
              }
            }
        }`,
        variables: { name: val }
      })
    })
      .catch((err) => console.log(err))

    return collectionsPromise?.data?.collections?.nodes.concat(
      collectionsPromise?.data?.draftCollections?.nodes,
    )
  }

  const searchCollectionsBitcoin = async (val: string) => {
    const collectionsPromise = await FetchApi({
      endpoint:`${GO_DE_GQL_BACKEND_URL}`, 
      method: "POST",
      body:  ({
        query: `
          query MyQuery($name: String) {
            ordinalsCollection(name: $name) {
              nodes {
                name
                id
              }
            }
            ordinalsDraftCollection(name: $name) {
              nodes {
                name
                id
              }
            }
        }`,
        variables: { name: val }
      })
    })
      .catch((err) => console.log(err))

    return collectionsPromise?.data?.ordinalsCollection?.nodes.concat(

      collectionsPromise?.data?.ordinalsDraftCollection?.nodes
    )
  }

  return (
    <div className="flex flex-col w-11/12 mx-auto mt-8 lg:mt-10 mx-6">
      <div className="mt-0 flex flex-row mb-4 justify-between items-center sm:flex-row">
        <h1 className="font-semibold text-3xl text-left">
          ADMIN NOTIFICATIONS
        </h1>
        <div className="w-full sm:w-auto flex items-center space-x-4">
          <select required name="blockchain" className="rounded-xl mb-0 sm:mb-2 btn bg-kyzzen-secondary border border-r-8 border-kyzzen-secondary flex items-center text-white border-gray-400 hover:bg-kyzzen-secondary " onChange={(e) => setCurrentBlockchain(e.target.value)} value={currentBlockchain} >
            <option value={Blockchain.Solana}>Solana</option>
            <option value={Blockchain.Bitcoin}>Bitcoin</option>
          </select>
          <Button
            type="button"
            className="mb-0 sm:mb-2 btn bg-kyzzen-primary border border-gray-70 flex items-center text-gray-70"
            onClick={onAddNewCollection}
          >
            ADD NEW COLLECTION
            <PlusCircleIcon className="h-5 inline ml-2" />
          </Button>
        </div>

      </div>
      <div className="flex">
        {" "}
        <Button
          type="button"
          className={`w-full my-2 mr-2 btn font-medium ${tab ? "bg-kyzzen-primary border border-gray-70" : "bg-gradient text-kyzzen-primary"}`}
          onClick={() => setTab(0)}
        // disabled={isLoadingCollections}
        >
          PENDING REVIEW
        </Button>
        <Button
          type="button"
          className={`w-full my-2 ml-2 btn font-medium ${!tab ? "bg-kyzzen-primary border border-gray-70" : "bg-gradient text-kyzzen-primary"}`}
          onClick={() => setTab(1)}
        // disabled={isLoadingCollections}
        >
          REVIEWED COLLECTIONS
        </Button>

      </div>
      <div>
        <InputField
          type="text"
          value={searchText}
          className="w-full mt-2 mb-1 mx-0"
          placeholder="Enter Search Text "
          onChange={(e) => setSearchText(e.target.value)}
        />
      </div>

      {
        searchText.length >= 2 &&
        <Fragment>
          <SearchList
            collections={searchItems}
          />
        </Fragment>
      }
      {
        (tab === 0 && currentBlockchain !== Blockchain.Bitcoin) &&
        <TabPendingSolana />
      }
      {
        (tab === 1 && currentBlockchain !== Blockchain.Bitcoin) &&
        <TabReviewedSolana />
      }

      {
        (tab === 0 && currentBlockchain === Blockchain.Bitcoin) &&
        <TabPendingBitcoin />
      }
      {
        (tab === 1 && currentBlockchain === Blockchain.Bitcoin) &&
        <TabReviewedBitcoin />
      }
      <br /><br />
    </div>
  )
})

export default AdminNotifications

const TabPendingSolana = () => {
  const {
    retrieveCollectionsByType,
  } = useApi()
  const { setIsLoadingOverlayDisplay } = useAuth()

  const [drafts, setDrafts] = useState<any>([])
  const [pending, setPending] = useState<any>([])

  useEffect(() => {
    fetchCollections()
  }, [])

  const fetchCollections = async () => {
    setIsLoadingOverlayDisplay(true)
    const allDrafts = await retrieveCollectionsByType({ orderBy: '-createdAt', offset: 0, limit: 100, }, 6)
    const allPendingCollection = await retrieveCollectionsByType({ state: CollectionState.pending, offset: 0, limit: 100, orderBy: '-modifiedAt' }, CollectionState.live)

    setDrafts(allDrafts)
    setPending(allPendingCollection)
    setIsLoadingOverlayDisplay(false)
  }

  return (
    <Fragment>
      <div className="mb-4">
        <h2 className="text-lg sm:text-2xl my-4">DRAFT</h2>
        <DraftList
          collections={drafts}
          stage={CollectionStage.draft}
        />
      </div>
      <div className="mb-4">
        <h2 className="text-lg sm:text-2xl my-4">PENDING</h2>
        <NotificationList
          collections={pending}
          state={CollectionState.pending}
        />
      </div>
    </Fragment>
  )
}
const TabReviewedSolana = () => {
  const {
    retrieveCollectionsByType,
  } = useApi()
  const { setIsLoadingOverlayDisplay } = useAuth()

  const [updated, setUpdated] = useState<any>([])
  const [verified, setVerified] = useState<any>([])
  const [rejected, setRejected] = useState<any>([])


  useEffect(() => {
    fetchCollections()
  }, [])

  const fetchCollections = async () => {
    setIsLoadingOverlayDisplay(true)
    const allUpdatedCollection = await retrieveCollectionsByType({ state: CollectionState.updated, orderBy: '-modifiedAt', offset: 0, limit: 100 }, CollectionState.updated)
    const verifeyedCollection = await retrieveCollectionsByType({ verifeyed: true, offset: 0, limit: 100, state: CollectionState.live, orderBy: '-modifiedAt' }, CollectionState.live);
    const allRejectedCollection = await retrieveCollectionsByType({ state: CollectionState.rejected, offset: 0, limit: 100, orderBy: '-modifiedAt' }, CollectionState.live)

    setUpdated(allUpdatedCollection)
    setVerified(verifeyedCollection)
    setRejected(allRejectedCollection)
    setIsLoadingOverlayDisplay(false)
  }

  return (
    <Fragment>
      <h2 className="text-lg sm:text-2xl my-4">UPDATED</h2>
      <NotificationList
        collections={updated}
        state={CollectionState.updated}
      />
      <h2 className="text-lg sm:text-2xl my-4">VERIFEYED</h2>
      <NotificationList
        collections={verified}
        stage={CollectionStage.live}
      />
      <h2 className="text-lg sm:text-2xl my-4">REJECTED</h2>
      <NotificationList
        collections={rejected}
        state={CollectionState.rejected}
      />
    </Fragment>
  )
}

const TabPendingBitcoin = () => {
  const {
    retrieveCollectionsByType,
  } = useApi()
  const { setIsLoadingOverlayDisplay } = useAuth()

  const [drafts, setDrafts] = useState<any>([])
  const [pending, setPending] = useState<any>([])

  useEffect(() => {
    fetchCollections()
  }, [])

  const fetchCollections = async () => {
    setIsLoadingOverlayDisplay(true)
    const allDrafts = await retrieveCollectionsByType({ orderBy: '-createdAt', offset: 0, limit: 100, }, 6, Blockchain.Bitcoin)
    const allPendingCollection = await retrieveCollectionsByType({ state: CollectionState.pending, offset: 0, limit: 100, orderBy: '-modifiedAt' }, CollectionState.live, Blockchain.Bitcoin)

    setDrafts(allDrafts)
    setPending(allPendingCollection)
    setIsLoadingOverlayDisplay(false)
  }

  return (
    <Fragment>
      <div className="mb-4">
        <h2 className="text-lg sm:text-2xl my-4">DRAFT</h2>
        <DraftList
          collections={drafts}
          stage={CollectionStage.draft}
        />
      </div>
      <div className="mb-4">
        <h2 className="text-lg sm:text-2xl my-4">PENDING</h2>
        <NotificationList
          collections={pending}
          state={CollectionState.pending}
        />
      </div>
    </Fragment>
  )
}
const TabReviewedBitcoin = () => {
  const {
    retrieveCollectionsByType,
  } = useApi()
  const { setIsLoadingOverlayDisplay } = useAuth()

  const [updated, setUpdated] = useState<any>([])
  const [verified, setVerified] = useState<any>([])
  const [rejected, setRejected] = useState<any>([])


  useEffect(() => {
    fetchCollections()
  }, [])

  const fetchCollections = async () => {
    setIsLoadingOverlayDisplay(true)
    const allUpdatedCollection = await retrieveCollectionsByType({ state: CollectionState.updated, orderBy: '-modifiedAt' }, CollectionState.updated, Blockchain.Bitcoin)
    const verifeyedCollection = await retrieveCollectionsByType({ verifeyed: true, offset: 0, limit: 100, state: CollectionState.live, orderBy: '-modifiedAt' }, CollectionState.live, Blockchain.Bitcoin);
    const allRejectedCollection = await retrieveCollectionsByType({ state: CollectionState.rejected, offset: 0, limit: 100, orderBy: 'modifiedAt' }, CollectionState.live, Blockchain.Bitcoin)

    setUpdated(allUpdatedCollection)
    setVerified(verifeyedCollection)
    setRejected(allRejectedCollection)
    setIsLoadingOverlayDisplay(false)
  }

  return (
    <Fragment>
      <h2 className="text-lg sm:text-2xl my-4">UPDATED</h2>
      <NotificationList
        collections={updated}
        state={CollectionState.updated}
      />
      <h2 className="text-lg sm:text-2xl my-4">VERIFEYED</h2>
      <NotificationList
        collections={verified}
        stage={CollectionStage.live}
      />
      <h2 className="text-lg sm:text-2xl my-4">REJECTED</h2>
      <NotificationList
        collections={rejected}
        state={CollectionState.rejected}
      />
    </Fragment>
  )
}